import { ApplicationRef, Directive, ElementRef, EmbeddedViewRef, HostListener, Injector, Input, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { environment } from 'environments/environment';

@Directive({
    selector: '[appERPLinkID]'
})
export class ERPLinkIDDirective implements OnInit {
    @Input('appERPLinkID') type!: 'user' | 'group'; // obligatoire
    private iconElement!: HTMLElement;
    private readonly hoverColor = '#e91e63';

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private injector: Injector,
        private viewContainerRef: ViewContainerRef,
        private appRef: ApplicationRef
    ) { }

    ngOnInit() {
        const host = this.el.nativeElement;

        // Style de base
        this.renderer.setStyle(host, 'cursor', 'pointer');
        this.renderer.setStyle(host, 'display', 'inline-flex');
        this.renderer.setStyle(host, 'align-items', 'center');
        this.renderer.setStyle(host, 'gap', '0.25em');
        this.renderer.setStyle(host, 'color', 'inherit');

        // Créer dynamiquement <mat-icon>
        const iconRef = this.viewContainerRef.createComponent(MatIcon, {
            injector: this.injector
        });
        iconRef.instance.fontIcon = 'open_in_new';
        iconRef.instance.inline = true;

        this.iconElement = (iconRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        this.renderer.setStyle(this.iconElement, 'font-size', 'inherit');
        this.renderer.setStyle(this.iconElement, 'line-height', '1');
        this.renderer.setStyle(this.iconElement, 'transition', 'color 0.2s');

        this.renderer.appendChild(host, this.iconElement);
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        this.renderer.setStyle(this.el.nativeElement, 'text-decoration', 'underline');
        this.renderer.setStyle(this.el.nativeElement, 'color', this.hoverColor);
        if (this.iconElement) {
            this.renderer.setStyle(this.iconElement, 'color', this.hoverColor);
        }
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.renderer.removeStyle(this.el.nativeElement, 'text-decoration');
        this.renderer.removeStyle(this.el.nativeElement, 'color');
        if (this.iconElement) {
            this.renderer.removeStyle(this.iconElement, 'color');
        }
    }

    @HostListener('click')
    onClick() {
        const text = this.el.nativeElement.innerText ?? this.el.nativeElement.value ?? '';
        let id: string | undefined;

        if (this.type === 'group') {
            id = text;
        } else if (this.type === 'user') {
            const match = text.match(/\(([^)]+)\)/);
            id = match?.[1];
        }

        if (id) {
            const url = this.getTargetUrl(id);
            console.log(url);
            window.open(url, '_blank');
        }
    }

    private getTargetUrl(id: string): string {
        switch (this.type) {
            case 'user':
                return `${environment.ERP_URL}content/manageUsers/${id}`;
            case 'group':
                return `${environment.ERP_URL}content/manageGroups/${id}`;
            default:
                return '';
        }
    }
}
